import { css } from '@emotion/core';
import { tokens, applyFont, media } from '@domain-group/fe-brary';
import { truncateLines } from '../../utils';
var typography = tokens.typography,
  colors = tokens.colors;
var showHeader = show => show ? null : /*#__PURE__*/css(media('>=tablet'), "{position:absolute;background:none;right:0;padding-right:20px;padding-top:16px;border-width:0px;}");
export var container = show => /*#__PURE__*/css("position:relative;height:60px;display:flex;justify-content:flex-end;align-items:center;gap:8px;padding:0 8px;z-index:1000;background:", colors.neutral.surface.default, ";border-bottom:1px solid ", colors.neutral.trim.default, ";", showHeader(show));
var isLeftClose = (type, _ref3) => {
  var appearance = _ref3.appearance,
    hasActions = _ref3.hasActions;
  if (['left-drawer', 'right-drawer'].includes(appearance[type])) {
    return true;
  }
  if (type === 'mobile') {
    return hasActions;
  }
  return false;
};
var _ref = {
  name: "xi606m",
  styles: "text-align:center;"
};
var _ref2 = {
  name: "1iuj5ih",
  styles: "padding-left:8px;"
};
export var heading = args => /*#__PURE__*/css("flex:1;", isLeftClose('mobile', args) ? _ref : _ref2, " ", media('>=tablet'), "{text-align:left;padding-left:", isLeftClose('tablet', args) ? 0 : '8px', ";}", media('>=desktop'), "{text-align:left;padding-left:", isLeftClose('desktop', args) ? 0 : '8px', ";}");
export var headingBody = /*#__PURE__*/css(applyFont(typography.heading), " ", truncateLines(2));
export var actions = show => /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";display:flex;", media('>=tablet'), "{display:", show ? 'flex' : 'none', ";}flex:0;");
export var dismiss = args => /*#__PURE__*/css("order:", isLeftClose('mobile', args) ? -1 : 'inherit', ";", media('>=tablet'), "{order:", isLeftClose('tablet', args) ? -1 : 'inherit', ";}", media('>=desktop'), "{order:", isLeftClose('desktop', args) ? -1 : 'inherit', ";}");